import React from "react";
import { DataGrid } from "devextreme-react/data-grid";
export const InventoryItemRecord = (props) => {
    const columns = [
        "ItemCode",
        "Description-1",
        "Description-2",
        "Status",
        "Class",
        "SubClass",
    ];
    const dataItmGrid = [
        {
            ItemCode: props?.itemObj?.itemCode,
            "Description-1": props?.itemObj?.itemDescription1,
            "Description-2": props?.itemObj?.itemDescription2,
            Status: props?.itemObj?.itemStatus,
            Class: props?.itemObj?.classCode,
            SubClass: props?.itemObj?.subClassCode,
        },
    ];
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                dataSource={dataItmGrid}
                defaultColumns={columns}
                showBorders={true}
            />
        </div>
    );
};